export default {
  title: '商品分類',
  addPrimary: '新增一級分類',
  addSecondary: '新增二級分類',
  collapseAll: '收起所有分類',
  language: '語言',
  categoryName: '分類名稱',
  categoryNamePlaceholder: '請輸入分類名稱',
  searchPlaceholder: '請輸入關鍵詞搜索',
  giftCount: '禮品數量',
  modify: '修改',
  multilingual: '多語言',
  addPrimaryTitle: '添加一級分類',
  addSecondaryTitle: '添加二級分類',
  editTitle: '修改分類',
  multiLangTitle: '多語言',
  deleteIrreversible: '刪除後不可恢復，確定要刪除嗎？',
  langRequired: '請選擇語言',
  nameRequired: '請輸入分類名稱',
  firstAddTip: '首次添加默認系統語言，如果是點擊【多語言】則默認列表查詢條件所選的語言',
};
